/**
 * Since the type of total value of an asset is uint64,
 * this is the maximum value that an asset can take on Algorand Blockchain.
 **/
// eslint-disable-next-line no-magic-numbers
const MAX_AMOUNT_VALUE = Math.pow(2, 64) - 1;

export {MAX_AMOUNT_VALUE};
